<template>
  <router-view></router-view>
</template>

<script>
import { defineComponent, onMounted } from '@vue/composition-api'

import '@/components/style/SPCommonCSS.vue'
import '@/components/style/module/LayoutSPCSS.vue'
export default defineComponent({
  setup (props, context) {
    const store = context.root.$store

    onMounted(() => {
    })

    return {

    }
  }
})
</script>
